import Profile from 'components/organisms/Profile';
import { routes } from 'defs';
import i18n, { labelExists } from 'helper/i18n';
import { template } from 'helper/string';
import { getWeightForDisplay } from 'helper/weight';
import camelCase from 'lodash.camelcase';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators as eventsAC } from 'store/events';
import {
	actionCreators,
	getActivityLevel,
	getBirthdate,
	getCoach,
	getEmail,
	getFirstName,
	getFullName,
	getGender,
	getGenderMeta,
	getHealthGoal,
	getHeight,
	getIsProfileLoaded,
	getLastName,
	getNutritionPhilosophy,
	getUserData,
	getWeight,
	getWeightReduceGoal,
} from 'store/profile';
import { getCurrentViewID } from 'store/view';
import { getAllergies } from './../../../store/profile/profile.selectors';

const profileLabelBase: string = 'react.impulsCoach.views.Profile';

function label(subkey: string): string {
	return i18n(`${profileLabelBase}.${subkey}`);
}

const defaultValue: string = label('defaultValue');

const mapStateToProps = (state) => ({
	currentViewID: getCurrentViewID(state),
	intensity: ((level: number): any => {
		if (level > -1) {
			let baseLabel: string = '';

			switch (level) {
				case 1:
					baseLabel = 'low';
					break;
				case 2:
					baseLabel = 'medium';
					break;
				case 3:
					baseLabel = 'high';
					break;
				default:
					break;
			}

			const intensity: string = `targets.intensity.${baseLabel}.title`;

			if (labelExists(`${profileLabelBase}.${intensity}`)) {
				return `${label(intensity)}`;
			}

			return defaultValue;
		}
	})(getActivityLevel(state)!),
	healthGoal: ((goal: string, reducer: number): string => {
		if (goal) {
			const mightTemplate: string = label(`targets.healthTarget.${camelCase(goal)}`);

			if (mightTemplate) {
				const desiredWeight = parseFloat(state.profile.userData.desiredWeight);
				return template(mightTemplate, {
					weightTarget: getWeightForDisplay(desiredWeight),
				});
			}
		}

		return defaultValue;
	})(getHealthGoal(state)!, getWeightReduceGoal(state)!),
	links: routes.profile.indexRoute.config,
	email: getEmail(state),
	genderMeta: getGenderMeta(state),
	ready: getIsProfileLoaded(state),
	fullName: getFullName(state),
	firstName: getFirstName(state),
	lastName: getLastName(state),
	birthdate: ((birthdate?: { year: number; monthValue: number; dayOfMonth: number }): string => {
		if (typeof birthdate !== 'object' || birthdate === null) {
			return defaultValue;
		}

		const data = [birthdate.year, birthdate.monthValue - 1, birthdate.dayOfMonth];
		const mask: string = 'DD.MM.YYYY';

		return moment(data).format(mask);
	})(getBirthdate(state)!),
	coach: getCoach(state),
	height: ((height: number): string => {
		if (height) {
			return `${height} ${label('bodyData.heightUnit')}`;
		}

		return defaultValue;
	})(getHeight(state)!),
	weight: ((weight: number): string => {
		if (weight) {
			return `${weight} ${label('bodyData.weightUnit')}`;
		}
		return defaultValue;
	})(getWeight(state)!),
	gender: getGender(state),
	nutritionPhilosophy: getNutritionPhilosophy(state),
	allergies: getAllergies(state),
	_data: getUserData(state),
});

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		{
			...actionCreators,
			doAddEvents: eventsAC.doAddEvents,
		},
		dispatch
	);
};

export default connect(mapStateToProps, mapDispatchToProps)(Profile as any);
